module.exports = __webpack_public_path__ + "img/image22@3x.6f018eeb.png";